module.exports = __webpack_public_path__ + "img/video_2.c420ab03.png";